<template>
	<section style="overflow-y: auto;height: calc(100vh - 105px);">

		<el-tabs v-model="activeName" @tab-click="handleClick">
    <el-tab-pane label="会员充值列表" name="first">
	<!--工具条-->
	<el-col :span="24" class="toolbar">
			<el-form :inline="true" :model="filters[0]" class="filterForm">
				<el-form-item label="用户名:" label-width="100px">
					<el-input v-model="filters[0].logName" auto-complete="off" class="formItem" size="small" />
				</el-form-item>
				<el-form-item label="手机号:" label-width="100px">
					<el-input v-model="filters[0].mobileNo" auto-complete="off" class="formItem" size="small" />
				</el-form-item>
				<el-form-item label="支付时间:" label-width="100px">
					<el-date-picker type="daterange" v-model="payTimes" value-format="yyyy-MM-dd" class="formItem"
						size="small"></el-date-picker>
				</el-form-item>
				<el-form-item>
					<el-button type="primary" v-on:click="getGridData0" size="small">查询</el-button>
				</el-form-item>
			</el-form>
		</el-col>
		<!--列表-->
		<el-table :data="grid_data[0]" height="calc(100vh - 240px)" border highlight-current-row @selection-change="(v) => { sels = v }" style="width: 100%;" :key="key0">
			<el-table-column prop="realName" label="用户姓名" width="100" show-overflow-tooltip></el-table-column>
			<el-table-column prop="logName" label="用户名" width="100" show-overflow-tooltip></el-table-column>
			<el-table-column prop="mobileNo" label="手机号" width="130"></el-table-column>
			<el-table-column prop="buyMonth" label="购买时长（月）" width="120"></el-table-column>
			<el-table-column prop="payMoney" label="支付金额" width="95"></el-table-column>
			<el-table-column prop="payTime" label="支付时间" width="140" :formatter="$util.dateFormatEx"></el-table-column>
			<el-table-column prop="payTransactionNo" label="支付流水号" width="200" show-overflow-tooltip></el-table-column>
			<el-table-column prop="memos" label="备注" min-width="150"></el-table-column>
		</el-table>
		<!--分页-->
		<pagination :totalPage="filters[0].total" :currentPage="filters[0].page" :pageSize="filters[0].rows"
					@pageSizeCallBack="(v) => { handleSizeChange(v, 0) }"
					@currentPageCallBack="(v) => { handleCurrentChange(v, 0) }"></pagination>
	</el-tab-pane>
    <el-tab-pane label="机构购买列表" name="second">
		<!--工具条-->
	<el-col :span="24" class="toolbar">
			<el-form :inline="true" :model="filters[1]" class="filterForm">
				<el-form-item label="机色名称:" label-width="100px">
					<el-input v-model="filters[1].schoolName" auto-complete="off" class="formItem" size="small" />
				</el-form-item>
				<el-form-item label="支付时间:" label-width="100px">
					<el-date-picker type="daterange" v-model="payTimes2" value-format="yyyy-MM-dd" class="formItem"
						size="small"></el-date-picker>
				</el-form-item>
				<el-form-item>
					<el-button type="primary" v-on:click="getGridData1" size="small">查询</el-button>
				</el-form-item>
			</el-form>
		</el-col>
		<!--列表-->
		<el-table :data="grid_data[1]" height="calc(100vh - 240px)" border highlight-current-row 
			@selection-change="(v) => { sels = v }" style="width: 100%;"  :key="key1">
			<el-table-column prop="schoolName" label="机构名称" width="200" show-overflow-tooltip></el-table-column>
			<el-table-column prop="buyMonth" label="购买时长（月）" width="120"></el-table-column>
			<el-table-column prop="payMoney" label="支付金额" width="95"></el-table-column>
			<el-table-column prop="payTime" label="支付时间" width="140" :formatter="$util.dateFormatEx"></el-table-column>
			<el-table-column prop="payTransactionNo" label="支付流水号" width="200" show-overflow-tooltip></el-table-column>
			<el-table-column prop="memos" label="备注" min-width="150"></el-table-column>
		</el-table>
		<!--分页-->
		<pagination :totalPage="filters[1].total" :currentPage="filters[1].page" :pageSize="filters[1].rows"
					@pageSizeCallBack="(v) => { handleSizeChange(v, 1) }"
					@currentPageCallBack="(v) => { handleCurrentChange(v, 1) }"></pagination>
	</el-tab-pane>
  </el-tabs>

	
	</section>
</template>
<script>
import pagination from '@/components/common/pagination.vue'
export default {
	components: {  pagination },
	data() {
		return {
			filters:[ {
				userId: '',
				mobileNo:'',
				logName:'',
				payType: '',
				payTime: '',
				payTime2: '',
				payStatus: 1,
				payTransactionNo: '',
				memos: '',
				rows: 10,
				page: 1,total: 0,
			},{
				schoolName:'',
				userId: '',
				mobileNo:'',
				logName:'',
				payType: '',
				payTime: '',
				payTime2: '',
				payStatus: 1,
				payTransactionNo: '',
				memos: '',
				rows: 10,
				page: 1,total: 0,
				isSchool:1,
			}
		],
		grid_data: [[], []],
			total: 0,
			listLoading: false,
			sels: [],//列表选中列
			showTitle: "",
			dialogAddShow: false,
			mid: 0,
			payTimes:[],
			payTimes2:[],
			activeName:'first',
			key0:new Date().getTime(),
			key1:new Date().getTime()
		}
	},
	methods: {
		handleSizeChange(val, index) {
			this.filters[index].rows = val;
			if (index == 0) {
				this.getGridData0();
			}
			else if (index == 1) {
				this.getGridData1();
			}

		},
		handleCurrentChange(val,index) {
			this.filters[index].page = val;
			if (index == 0) {
				this.getGridData0();
			}
			else if (index == 1) {
				this.getGridData1();
			}
		},
		//获取列表
		getGridData0() {
			this.listLoading = true;
			this.$util.dealQueryDateRange(this.filters[0], this.payTimes, "payTime")
			let formData = this.$util.jsonToForm(this.filters[0]);
			this.$axios.post("/school/getuserviprecordlist", formData).then(res => {
				this.filters[0].total = res.data.total;
				this.grid_data[0] = res.data.data;
				this.key0=new Date().getTime()
			});
		},
		getGridData1() {
			this.listLoading = true;
			this.$util.dealQueryDateRange(this.filters[1], this.payTimes2, "payTime")
			let formData = this.$util.jsonToForm(this.filters[1]);
			this.$axios.post("/school/getuserviprecordlist", formData).then(res => {
				this.filters[1].total = res.data.total;
				this.grid_data[1] = res.data.data;
				this.key1=new Date().getTime()
			});
		},
	},
	async created() {
		this.getGridData0();
		this.getGridData1();
	}
}

</script>

<style scoped></style>
